import { rpcBaseUrl } from '@/api/config';
/** Stream links are rooted at the backend origin, separately from the /api RPC prefix. */
export function resolvePreviewStreamUrl(pathOrUrl: string): string {
  return new URL(pathOrUrl, new URL(rpcBaseUrl).origin).href;
}
